<template>
  <t-option-group
    class="tlbs-option-group"
    v-bind="$attrs"
  >
    <slot />
  </t-option-group>
</template>

<script lang="ts" setup name="TlbsOptionGroup">
</script>
